<template>
  <div class="user-details details">
    <div class="close" v-on:click="close()">
      <b-icon icon="close" size="is-large" />
    </div>
    <ul v-if="errorMessages.length > 0" class="error messages">
      <li v-for="(msg, mi) in errorMessages" :key="['error', mi].join('-')">{{msg}}</li>
    </ul>
    <div class="user-data">
      <b-field label="First name(s)" class="name-row">
        <b-input maxlength="128" type="text" v-model="firstName"></b-input>
      </b-field>
      <b-field label="Last name(s)" class="name-row">
        <b-input maxlength="128" type="text" v-model="lastName"></b-input>
      </b-field>
      <b-field label="Email" class="email-row">
        <b-input maxlength="128" type="text" v-model="identifier"></b-input>
      </b-field>
      <b-field v-if="!isNew" label="Edit password" class="active-group">
        <b-switch v-model="showPassword">{{showPassword|yesNo}}</b-switch>
      </b-field>
      <b-field v-if="showPassword" label="Password" class="password-row">
        <b-input
          maxlength="20"
          type="password"
          pattern="[a-zA-Z0-9_;.:-]+"
          minlength="8"
          v-model="password"
        ></b-input>
      </b-field>
      <b-field v-if="showPassword" label="Confirm password" class="password-row">
        <b-input
          maxlength="20"
          type="password"
          pattern="[a-zA-Z0-9_;.:-]+"
          minlength="8"
          v-model="cpassword"
        ></b-input>
      </b-field>
      <b-field>
        <b-radio-button v-model="role" native-value="admin" type="is-success">Administrator</b-radio-button>
        <b-radio-button v-model="role" native-value="selector" type="is-success">Selector</b-radio-button>
        <b-radio-button v-model="role" native-value="remote_selector" type="is-success">Remote Selector</b-radio-button>
      </b-field>
      <b-field label="Active" class="active-group">
        <b-switch v-model="active">{{active|yesNo}}</b-switch>
        <b-button v-if="mayDelete" @click="deleteUser" icon-left="delete" rounded>Delete</b-button>
      </b-field>
      <b-button type="is-success" @click="save" class="save" rounded>Save</b-button>
      <p v-if="saveMessage.length > 2" class="message">{{saveMessage}}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { updateUser, registerUser } from "../api/methods";
import { validPassword, validEmail } from "../api/validators";
import filters from "../mixins/filters";
import { userSchema } from "../store/schemas";

export default {
  name: "UserDetail",
  components: {},
  props: {
    user: {
      type: Object,
      default() {
        return userSchema;
      }
    }
  },
  mixins: [filters],
  data() {
    return {
      ...userSchema,
      password: "",
      cpassword: "",
      showPassword: false,
      saveMessage: "",
      errorMessages: []
    };
  },
  mounted() {
    this.assignUser();
  },
  computed: {
    ...mapGetters(["settings"]),
    mayDelete() {
      return !this.active;
    },
    isNew() {
      return this.user._id.length < 6;
    }
  },
  methods: {
    close() {
      this.$parent.close();
    },
    assignUser() {
      if (this.user instanceof Object) {
        const {
          _id,
          firstName,
          lastName,
          role,
          active,
          identifier
        } = this.user;
        if (_id) {
          this._id = _id;
        }
        if (firstName) {
          this.firstName = firstName;
        }
        if (lastName) {
          this.lastName = lastName;
        }
        if (identifier) {
          this.identifier = identifier;
        }
        if (role) {
          this.role = role;
        }
        if (active) {
          this.active = active;
        }
        if (this.isNew) {
          this.showPassword = true;
        }
      }
    },
    save() {
      let valid = true;
      let data = {};
      const { _id } = this.user;
      this.errorMessages = [];
      if (this.showPassword) {
        this.password = this.password.trim();
        this.cpassword = this.cpassword.trim();
        valid = validPassword(this.password);
        if (valid) {
          valid = this.password === this.cpassword;
          data.password = this.password;
          if (!valid) {
            this.errorMessages.push("Passwords do not match");
          }
        } else {
          this.errorMessages.push(
            "Please enter a password with at least 8 characters including one lower-case letter, one upper-case letter and one numeral. The following other symbols may be used: _;.:-"
          );
        }
      }
      this.firstName = this.firstName.trim();
      this.lastName = this.lastName.trim();
      this.identifier = this.identifier.trim();
      if (this.firstName.length < 2) {
        valid = false;
        this.errorMessages.push("Please enter a first name");
      } else {
        data.firstName = this.firstName;
      }

      if (this.lastName.trim().length < 2) {
        valid = false;
        this.errorMessages.push("Please enter a last name");
      } else {
        data.lastName = this.lastName;
      }
      if (!validEmail(this.identifier)) {
        valid = false;
        this.errorMessages.push("Please enter a valid email address");
      } else {
        data.identifier = this.identifier;
      }
      data.role = this.role;
      data.source = "local";
      data.active = this.active;
      if (valid) {
        if (this.isNew) {
          registerUser(data).then(res => {
            if (res.valid) {
              this.update();
            }
          });
        } else {
          updateUser(_id, data).then(res => {
            if (res.user) {
              this.update();
            }
          });
        }
      }
    },
    deleteUser() {},
    update() {
      this.$parent.update();
      setTimeout(this.close, 1000);
    }
  }
};
</script>